<a data-test="home-redirection-button"
   class="absolute top-6 portrait:right-6 landscape:left-6"
   *ngIf="redirectionLink"
   [href]="redirectionLink"
   (click)="store.clearRedirectionLink()"
>
  <cds-svg-icon name="home"></cds-svg-icon>
</a>
